import RenderWhen from "../../../../../components/RenderWhen";
import TooltipIcon from "../../../../../components/TooltipIcon";
import { enums } from "../../../../../shim/jsbridge";
import Name from "../../../../search/schema/components/Name";
import { SuricataSnortAlert } from "./types";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};
const LEGACY_ALERT_MESSAGE = "Legacy Snort Alert";

export const RlCloudSandboxSuricataAlertsSchema = {
  fields: [
    {
      name: "rule",
      displayTitle: "Rule ID",
      component: (item: SuricataSnortAlert) => (
        <div className={"flex align-center flex-gap-1"}>
          {item.source_id || item.rule || "--"}
          {item.rule && (
            <TooltipIcon icon="info-circle" message={LEGACY_ALERT_MESSAGE} />
          )}
        </div>
      ),
      sortable: true,
      style: {
        width: "8%"
      }
    },
    {
      name: "message",
      displayTitle: "Message",
      component: (item: SuricataSnortAlert) => item.message || "--",
      sortable: true,
      style: {
        width: "23%"
      }
    },
    {
      name: "classification_type",
      displayTitle: "Classification Type",
      component: (item: SuricataSnortAlert) => item.classification_type || "--",
      sortable: true,
      style: {
        width: "14%"
      }
    },
    {
      name: "protocol",
      displayTitle: "Protocol",
      component: (item: SuricataSnortAlert) => item.protocol || "--",
      sortable: true,
      style: {
        width: "7%"
      }
    },
    {
      name: "source_ip",
      displayTitle: "Source IP",
      component: (item: SuricataSnortAlert) => (
        <RenderWhen condition={!!item.source_ip} fallback={"--"}>
          <Name
            data={{
              file_name: item.source_ip,
              int_submission_analyzer: URLANALYZER
            }}
          />
        </RenderWhen>
      ),
      sortable: true,
      style: {
        width: "13%"
      }
    },
    {
      name: "source_port",
      displayTitle: "Source Port",
      component: (item: SuricataSnortAlert) => item.source_port || "--",
      sortable: true,
      style: {
        width: "10%"
      }
    },
    {
      name: "destination_ip",
      displayTitle: "Destination IP",
      component: (item: SuricataSnortAlert) => (
        <RenderWhen condition={!!item.destination_ip} fallback={"--"}>
          <Name
            data={{
              file_name: item.destination_ip,
              int_submission_analyzer: URLANALYZER
            }}
          />
        </RenderWhen>
      ),
      sortable: true,
      style: {
        width: "14%"
      }
    },
    {
      name: "destination_port",
      displayTitle: "Destination Port",
      component: (item: SuricataSnortAlert) => item.destination_port || "--",
      sortable: true,
      style: {
        width: "11%"
      }
    }
  ]
};
